import BaseModel from './base';

export default class UserDuplicateMemberProfile extends BaseModel {
  constructor(userDuplicateMemberProfile) {
    super(userDuplicateMemberProfile);

    this.public_name = userDuplicateMemberProfile.public_name;
    this.email = userDuplicateMemberProfile.email; // string | null
    this.phone = userDuplicateMemberProfile.phone; // string | null
    this.birthday_at = userDuplicateMemberProfile.birthday_at;
    this.region = userDuplicateMemberProfile.region; // { id: number; name: string }; | { id: null; name: null };
    this.municipality = userDuplicateMemberProfile.municipality; // { id: number; name: string }; | { id: null; name: null };
  }
}
